// ─── TheBigHub site configuration ────────────────────────────────────────────
// Edit contact details, social links and the Google Form URL here.

export const site = {
  name: 'TheBigHub',
  tagline: 'Your Digital Growth Partner',
  message: 'One Hub. Many Solutions. Maximum Impact.',
  email: 'TheBigHub100@gmail.com',
  whatsappDisplay: '09138299631',
  whatsappLink: 'https://wa.me/message/WP4FD3DIWB4BP1',
  whatsappPrefill:
    'https://wa.me/2349138299631?text=' +
    encodeURIComponent('Hello TheBigHub, I would like to discuss your digital services.'),
  selarEbookUrl: 'https://selar.com/7713365823',
  courseFormUrl:
    'https://docs.google.com/forms/d/e/1FAIpQLSfxswodDif2sHoREh239NCKCdTRyGsqCcXnzrVJZXj1jv5zyA/viewform',
  bank: {
    bankName: 'First Bank',
    accountNumber: '2049243237',
    accountName: 'THE BIG HUB',
  },
  // Drop the official Google Form link here when ready — the contact form will open it.
  googleFormUrl: '',
  socials: [
    { label: 'Instagram', url: '' },
    { label: 'Facebook', url: '' },
    { label: 'X (Twitter)', url: '' },
    { label: 'LinkedIn', url: '' },
    { label: 'TikTok', url: '' },
  ],
  nav: [
    { label: 'Home', to: '/' },
    { label: 'About', to: '/about' },
    { label: 'Services', to: '/services' },
    { label: 'Courses', to: '/courses' },
    { label: 'Portfolio', to: '/portfolio' },
    { label: 'Insights', to: '/insights' },
    { label: 'Contact', to: '/contact' },
  ],
};

// Analytics-ready event tracking — fires only when GA4 (gtag) or Meta Pixel (fbq) are configured.
export const trackEvent = (event, params = {}) => {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event, ...params });
  if (typeof window.gtag === 'function') window.gtag('event', event, params);
  if (typeof window.fbq === 'function') window.fbq('trackCustom', event, params);
};

export const img = (id, w = 1400) =>
  `https://images.unsplash.com/${id}?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&q=80&w=${w}`;
